var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { emptyFile } from "../constants";
import { createWebEditorModuleSource, extractExerciseArchive } from "../services/patch_exercise";
import { getExerciseDetails, getExerciseZip, getOldSubmissions, getSubmissionZip } from "../services/programming_exercise";
export default function useExercise(organization, course, exercise, userId, token) {
  var _this = this;
  var _a = useState(false),
    ready = _a[0],
    setReady = _a[1];
  var _b = useState(),
    details = _b[0],
    setDetails = _b[1];
  var _c = useState([emptyFile]),
    projectFiles = _c[0],
    setProjectFiles = _c[1];
  var _d = useState(),
    submissionDetails = _d[0],
    setSubmissionDetails = _d[1];
  var _e = useState([]),
    templateIssues = _e[0],
    setTemplateIssues = _e[1];
  var _f = useState(),
    testCode = _f[0],
    setTestCode = _f[1];
  var t = useTranslation()[0];
  useEffect(function () {
    var effect = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var apiConfig, details_1, template, latestSubmissionDetails, submission_1, e_1;
        var _a, _b;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              _c.trys.push([0, 7,, 8]);
              apiConfig = {
                token: token,
                t: t
              };
              return [4, getExerciseDetails(organization, course, exercise, apiConfig)];
            case 1:
              details_1 = _c.sent();
              setDetails(details_1);
              if (!details_1.downloadable) {
                setProjectFiles([__assign(__assign({}, emptyFile), {
                  content: "# " + t("exerciseNotYetUnlocked")
                })]);
                setTemplateIssues([]);
                setTestCode(undefined);
                return [2];
              }
              return [4, getExercise(organization, course, exercise, apiConfig)];
            case 2:
              template = _c.sent();
              if (!userId || !token) {
                setProjectFiles(template.srcFiles);
                setTemplateIssues((_a = template.problems) !== null && _a !== void 0 ? _a : []);
                setTestCode(template.testSource);
                return [2];
              }
              return [4, getLatestSubmissionDetails(details_1.id, apiConfig)];
            case 3:
              latestSubmissionDetails = _c.sent();
              if (!latestSubmissionDetails) return [3, 5];
              return [4, getSubmission(latestSubmissionDetails.id, apiConfig)];
            case 4:
              submission_1 = _c.sent();
              if (submission_1) {
                setProjectFiles(template.srcFiles.map(function (templateFile) {
                  var submittedFile = submission_1.srcFiles.find(function (y) {
                    return y.fullName === templateFile.fullName;
                  });
                  return submittedFile ? __assign(__assign({}, templateFile), {
                    content: submittedFile.content
                  }) : templateFile;
                }));
              } else {
                setProjectFiles(template.srcFiles);
              }
              return [3, 6];
            case 5:
              setProjectFiles(template.srcFiles);
              _c.label = 6;
            case 6:
              setSubmissionDetails(latestSubmissionDetails);
              setTemplateIssues((_b = template.problems) !== null && _b !== void 0 ? _b : []);
              setTestCode(template.testSource);
              return [3, 8];
            case 7:
              e_1 = _c.sent();
              setDetails(undefined);
              if (e_1 instanceof Error) {
                setProjectFiles([__assign(__assign({}, emptyFile), {
                  content: "# " + e_1.message
                })]);
              } else {
                setProjectFiles([__assign(__assign({}, emptyFile), {
                  content: "# Unknown error."
                })]);
              }
              setSubmissionDetails(undefined);
              setTemplateIssues([]);
              setTestCode(undefined);
              return [3, 8];
            case 8:
              return [2];
          }
        });
      });
    };
    if (organization && course && exercise) {
      setReady(false);
      effect().then(function () {
        return setReady(true);
      });
    } else {
      setReady(true);
    }
  }, [organization, course, exercise, userId, token, t]);
  var getTestProgram = useCallback(function (code) {
    return "\n__webeditor_module_source = " + createWebEditorModuleSource(code) + "\n" + testCode + "\n";
  }, [testCode]);
  var reset = useCallback(function () {
    setProjectFiles(function (prev) {
      return prev.map(function (x) {
        return __assign(__assign({}, x), {
          content: x.originalContent
        });
      });
    });
  }, []);
  var updateDetails = useCallback(function () {
    return __awaiter(_this, void 0, void 0, function () {
      var details_2, e_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4, getExerciseDetails(organization, course, exercise, {
              token: token,
              t: t
            })];
          case 1:
            details_2 = _a.sent();
            setDetails(details_2);
            return [3, 3];
          case 2:
            e_2 = _a.sent();
            return [3, 3];
          case 3:
            return [2];
        }
      });
    });
  }, [organization, course, exercise, token, t]);
  return {
    details: details,
    getTestProgram: getTestProgram,
    templateIssues: templateIssues,
    projectFiles: projectFiles,
    ready: ready,
    reset: reset,
    submissionDetails: submissionDetails,
    updateDetails: updateDetails
  };
}
var getExercise = function (organization, course, exercise, apiConfig) {
  return __awaiter(void 0, void 0, void 0, function () {
    var zip, parsed;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4, getExerciseZip(organization, course, exercise, apiConfig)];
        case 1:
          zip = _a.sent();
          return [4, extractExerciseArchive(zip, apiConfig)];
        case 2:
          parsed = _a.sent();
          return [2, parsed];
      }
    });
  });
};
var getLatestSubmissionDetails = function (exerciseId, apiConfig) {
  return __awaiter(void 0, void 0, void 0, function () {
    var submissions, latest;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          return [4, getOldSubmissions(exerciseId, apiConfig)];
        case 1:
          submissions = _a.sent();
          if (submissions.length <= 0) {
            return [2, undefined];
          }
          latest = submissions.reduce(function (latest, current) {
            return current.createdAtMillis > latest.createdAtMillis ? current : latest;
          }, submissions[0]);
          return [2, latest];
      }
    });
  });
};
var getSubmission = function (submissionId, apiConfig) {
  return __awaiter(void 0, void 0, void 0, function () {
    var zip, parsed, e_3;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          _a.trys.push([0, 3,, 4]);
          return [4, getSubmissionZip(submissionId, apiConfig)];
        case 1:
          zip = _a.sent();
          return [4, extractExerciseArchive(zip, apiConfig)];
        case 2:
          parsed = _a.sent();
          return [2, parsed];
        case 3:
          e_3 = _a.sent();
          return [2, undefined];
        case 4:
          return [2];
      }
    });
  });
};